import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const CronjobIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <path d="M12.03,16.36H1.33c-.74,0-1.33-.6-1.33-1.33V6.61c0-.74.6-1.33,1.33-1.33h12.91c.74,0,1.33.6,1.33,1.33v1.57c0,.29-.24.53-.53.53s-.53-.24-.53-.53v-1.57c0-.15-.13-.28-.28-.28H1.33c-.15,0-.28.13-.28.28v8.41c0,.15.13.28.28.28h10.7c.29,0,.53.24.53.53s-.24.53-.53.53Z" />
  <path d="M10.86,6.33c-.29,0-.53-.24-.53-.53v-2.02c0-.15-.13-.28-.28-.28h-4.52c-.15,0-.28.13-.28.28v2.02c0,.29-.24.53-.53.53s-.53-.24-.53-.53v-2.02c0-.74.6-1.33,1.33-1.33h4.52c.74,0,1.33.6,1.33,1.33v2.02c0,.29-.24.53-.53.53Z" />
  <path d="M11.94,9.99H.53c-.29,0-.53-.24-.53-.53s.24-.53.53-.53h11.41c.29,0,.53.24.53.53s-.24.53-.53.53Z" />
  <path d="M15.05,17.55c-2.73,0-4.95-2.22-4.95-4.95s2.22-4.95,4.95-4.95,4.95,2.22,4.95,4.95-2.22,4.95-4.95,4.95ZM15.05,8.71c-2.15,0-3.89,1.75-3.89,3.89s1.75,3.89,3.89,3.89,3.89-1.75,3.89-3.89-1.75-3.89-3.89-3.89Z" />
  <path d="M16.17,14.25c-.13,0-.27-.05-.37-.15l-1.12-1.12c-.1-.1-.15-.23-.15-.37v-2.56c0-.29.24-.53.53-.53s.53.24.53.53v2.34l.96.96c.21.21.21.54,0,.74-.1.1-.24.15-.37.15Z" />
 </svg>,
 "Cronjob"
);
